import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import { useGlobalStore } from '@/stores/global'
import router from '@/router'
import { useAuthStore } from '@/stores/auth'
import lookups from '@/assets/json/clientLookups.json'

const initForm = () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '', withException = '' } = router.currentRoute.value.query
  const {
    eidaCardDurationId,
    eidaCardDurationCode,
    module: { ICA },
    applicatClassType: { gCC },
    applicationRequestType: { newIDCard, renewIDCard },
    eidaServices: { issueNewIDForGccCitizen, renewIDForGccCitizen },
    adminRegions: { abuDhabi }
  } = lookups
  formStore.extraMap = {
    ...formStore.extraMap,
    gccClassificationList: [],
    gccTypesList: [],
    gccRelationList: [],
    deletedAttachments: [],
    auditedAttachments: [],
    greaterthan18: false,
    userHadTheOldCardOrCopy: 0,
    formPayload: null,
    gccTypeCode: 0,
    gccCategoryCode: 0,
    showGccCategoryCodeList: false,
    withException: false,
    administrativeRegionId: administrativeRegionId || abuDhabi,
    serviceTransactionId,
    showQualificationLevel: false,
    showWorkType: false,
    showChangePersonPhoto: false,
    enableRenew: serviceTransactionId == 574
  }
  formStore.draft.request = {
    ...formStore.draft.request,
    newIdCardDurationId: eidaCardDurationId.fiveYears,
    numberOfYears: eidaCardDurationCode.fiveYears,
    fileModuleId: ICA,
    applicantClassId: gCC
  }
  if (issueNewIDForGccCitizen == serviceTransactionId)
    formStore.draft.request.applicationRequestTypeId = newIDCard
  if (renewIDForGccCitizen == serviceTransactionId) {
    formStore.draft.request.applicationRequestTypeId = renewIDCard
  }
}

const ageGreaterThan18 = () => {
  const formStore = useFormStore()
  const { dateOfBirth } = formStore.form.values
  const birthDate = new Date(dateOfBirth)
  const today = new Date()

  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDifference = today.getMonth() - birthDate.getMonth()
  const dayDifference = today.getDate() - birthDate.getDate()

  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--
  }
  formStore.extraMap.greaterthan18 = age >= 18
}

const setDefualtValues = () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const { userName } = authStore.user
  formStore.form.setFieldValue('applicantEmail', userName)
}

const initInfo = async () => {
  const formStore = useFormStore()
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    formStore.draft.request.individualInfo = res
    ageGreaterThan18()
    setDefualtValues()
  }
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use573Preload error: ', error)
  }
}
